import { MARKET_TYPE, SEC_TYPE } from 'const/stock'

/**
 * 判断是否需要刷新数据
 * @param {object} stock - 标的信息
 * @param {object} getters - getters 数据，包含盘前盘后状态等
 * @param {boolean} inChart - 是否是图表刷新，图表数据只在盘中刷新绘制。默认：false
 * @returns {boolean}
 */
export default function(stock, getters, inChart = false) {
  if (!stock) return false
  let isUsRefreshTime = false
  if (stock.secType === SEC_TYPE.OPT || inChart) {
    isUsRefreshTime = getters.usMarketOpen
  } else {
    isUsRefreshTime = getters.usMarketOpen || getters.usHourTrading
  }
  const isUsMarketAndOpen = stock.market === MARKET_TYPE.US && isUsRefreshTime
  const isHkMarketAndOpen =
    stock.market === MARKET_TYPE.HK && getters.hkMarketOpen
  const isCnMarketAndOpen =
    MARKET_TYPE.A.includes(stock.market) && getters.cnMarketOpen
  const marketIsOpen =
    isUsMarketAndOpen || isHkMarketAndOpen || isCnMarketAndOpen
  const hasPermission =
    getters.hasHkLv2Permission || stock.market !== MARKET_TYPE.HK

  return marketIsOpen && hasPermission
}
